import * as React from "react"
import { useIntl } from "react-intl"

const DISCLAIMER_TEXT_ID =
	"phronesis.customerbehavior.application.switching.data.client.disclaimer"

const TreeDisclaimer = () => {
	const intl = useIntl()

	return (
		<p className="data-client-disclaimer">
			{intl.formatMessage(
				{
					id: DISCLAIMER_TEXT_ID,
				},
				{ b: (str) => <b>{str}</b> }
			)}
		</p>
	)
}

export default TreeDisclaimer
